import styled from "styled-components";

export const Error = styled.p`
  color: ${({ theme }) => theme.colors.coral};
  font-size: 10px;
`;
